/**
 * Theme Requirements Aggregation for Case Associates Lp
 * 
 * Extends the base landing-page theme requirements with Case Associates Lp specific
 * component requirements.
 */

import type { ComponentRequirements } from '@vibesites/tokens';
import { componentRequirements as baseRequirements } from '@vibesites/theme-landing-page/requirements';

/**
 * Case Associates Lp component requirement overrides.
 * Add requirements for any override components here.
 */
const caseassociateslpOverrides: Record<string, ComponentRequirements> = {
  // Example:
  // Footer: FooterRequirements,
};

/**
 * All component requirements for the Case Associates Lp theme.
 * Inherits from landing-page theme and overrides with Case Associates Lp components.
 */
export const componentRequirements: Record<string, ComponentRequirements> = {
  ...baseRequirements,
  ...caseassociateslpOverrides,
};

/**
 * Get requirements for a specific component.
 */
export function getComponentRequirements(componentName: string): ComponentRequirements | undefined {
  return componentRequirements[componentName];
}

/**
 * Get all component names that have requirements defined.
 */
export function getRegisteredComponentNames(): string[] {
  return Object.keys(componentRequirements);
}
